import Chart from 'chart.js';

Chart.defaults.LineWithLine = Chart.defaults.line;
Chart.controllers.LineWithLine = Chart.controllers.line.extend({
  draw(ease) {
    Chart.controllers.line.prototype.draw.call(this, ease);

    const tooltip = this.chart && this.chart.tooltip;
    const active = tooltip && tooltip._active;
    if (!active || !active.length) {
      return;
    }

    const activePoint = active[0];
    if (!activePoint || typeof activePoint.tooltipPosition !== 'function') {
      return;
    }

    const { ctx } = this.chart;
    const yScale = this.chart.scales && this.chart.scales['y-axis-0'];
    if (!ctx || !yScale) {
      return;
    }

    const { x } = activePoint.tooltipPosition();
    const topY = yScale.top;
    const bottomY = yScale.bottom;

    ctx.save();
    ctx.beginPath();
    ctx.moveTo(x, topY);
    ctx.lineTo(x, bottomY);
    ctx.lineWidth = 0.5;
    ctx.strokeStyle = '#ddd';
    ctx.stroke();
    ctx.restore();
  },
});

export default Chart;
